<template>
  <v-app id="inspire" light>
    <Header
      :class="!drawer ? 'ml-4' : null"
      :style="drawer ? `left: 256px` : null"
      :menuRouter="menuRouter"
    />

    <v-navigation-drawer v-model="drawer" app>
      <v-list dense>
        <v-list-item-title class>
          <v-row justify="center">
            <img
              alt="Vue logo"
              height="35"
              class="mr-4 my-5"
              src="@/assets/logo_header.svg"
            />
          </v-row>
        </v-list-item-title>
        <Sidebar class="mt-2" :items="menuRouter" />
      </v-list>
      <!-- <template v-slot:append>
        <div class="pa-4 d-flex justify-space-around font-weight-medium">
          <span v-if="masterData.release == 'APPROVED'">{{
            `v${masterData.active_version}`
          }}</span>
          <span v-else
            >{{ `v${masterData.active_version}` }}
            <v-icon size="12">fas fa-arrow-right</v-icon>
            {{ `v${masterData.release_version}` }}
          </span>
          <v-btn
            color="primary"
            :disabled="statusVersion"
            small
            @click="release"
            :loading="loadingRelase"
            >Release</v-btn
          >
        </div>
      </template> -->
    </v-navigation-drawer>

    <v-main :class="drawer ? 'main-style-drawer' : 'main-style-not-drawer'">
      <MainView>
        <router-view />
      </MainView>
    </v-main>
  </v-app>
</template>

<script>
import MainView from "./MainView";
import Sidebar from "./Sidebar";
import Header from "./Header";
export default {
  store: ["drawer"],
  name: "BasicLayout",
  props: {
    source: String,
  },
  components: {
    MainView,
    Sidebar,
    Header,
  },
  data: () => ({
    menuRouter: [],
  }),
  created() {
    this.menuRouter = this.$router.options.routes.filter(
      (item) => item.path !== "/"
    );
  },
};
</script>
<style lang="scss" scoped>
.toolbar-title {
  font-size: 1.8rem;
}
.v-list-item__content > * {
  line-height: 1.3;
  width: 3.9rem;
}
header {
  margin: 16px 11px 16px 34px !important;
  border-radius: 16px !important;
}
nav {
  max-height: calc(100% - 34px) !important;
  margin: 16px;
  border-radius: 16px !important;
}
.main-style-drawer {
  padding: 96px 11px 16px 290px !important;
}
.main-style-not-drawer {
  padding: 96px 11px 16px 16px !important;
}
</style>
